import Modal from 'react-bootstrap/Modal';
import { IoClose } from 'react-icons/io5';
import modalStyles from '../../css/style.module.css';
import downloadStyles from './TimesheetDownloadModal.module.css';

const TimesheetApproveModal = ({
  show,
  onHide,
  onConfirm,
  approving,
  staffName,
  customerName,
}) => {
  return (
    <Modal show={show} onHide={onHide} size="sl" centered>
      <Modal.Body>
        <div className={modalStyles.modaldownload}>
          <div className={modalStyles.modaldownloadheading}>
            <h6>{approving ? 'Approving Shift' : 'Confirm Staff Approval'}</h6>
            {!approving && <IoClose color="#000000" size={25} onClick={onHide} />}
          </div>

          <div className={downloadStyles.summaryBox}>
            {approving ? (
              <p className={downloadStyles.message}>
                Approving staff shift for <strong>{staffName || 'this employee'}</strong>...
              </p>
            ) : (
              <>
                <p className={downloadStyles.message}>
                  Are you sure you want to approve this staff shift on behalf of the customer?
                </p>
                {staffName && (
                  <div className={downloadStyles.detailRow}>
                    <span>Employee</span>
                    <strong>{staffName}</strong>
                  </div>
                )}
                {customerName && (
                  <div className={downloadStyles.detailRow}>
                    <span>Customer</span>
                    <strong>{customerName}</strong>
                  </div>
                )}
              </>
            )}
          </div>

          {!approving && (
            <div className={modalStyles.modaldownloadbutton} style={{ display: 'flex', gap: '12px' }}>
              <button type="button" onClick={onHide} style={{ background: '#5A5A5A' }}>
                Cancel
              </button>
              <button type="button" onClick={onConfirm}>
                Confirm Approval
              </button>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TimesheetApproveModal;
